module.exports = __webpack_public_path__ + "static/opening-e45f63f5eef39eacf4f0f30160563eb1.jpg";